/* eslint-disable newline-per-chained-call */
import { customerAdminRouteConfig } from './customerAdministration';
import { userAdminRouteConfig } from './userAdministration';
import { routeConfig as trainingAdminRouteConfig } from './trainingAdministration';
import { vendorManagementAdminRouteConfig } from './vendorManagementAdministration';
import { controlAdminRouteConfig } from './controlAdministration';
import { riskAdminRouteConfig } from './riskAdministration';
import { assetAdminRouteConfig } from './assetAdministration';

export default function routes($routeProvider, $locationProvider) {
  $locationProvider.hashPrefix('');
  $routeProvider.when(
    //   '/admin',
    //   customerAdminRouteConfig
    // ).when(
    '/admin/client-administration',
    customerAdminRouteConfig
  ).when(
    '/admin/user-administration',
    userAdminRouteConfig
  ).when(
    '/admin/training-administration',
    trainingAdminRouteConfig
  ).when(
    '/admin/vendor-management-administration',
    vendorManagementAdminRouteConfig
  ).when(
    '/admin/control-administration',
    controlAdminRouteConfig
  ).when(
    '/admin/risk-administration',
    riskAdminRouteConfig,
  ).when(
    '/admin/asset-administration',
    assetAdminRouteConfig,
  );
}

routes.$inject = ['$routeProvider', '$locationProvider'];
console.log('app.components.admin.routes loaded');
